import { useCurrentAgreement } from '@economic/react-app';
import { AlertDialog, Button, Dialog, Group } from '@economic/taco';
import { t, Trans } from '@lingui/macro';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoadingBox } from '~/shared-ui';
import internalApiClient from '../../../../../shared/util/api/internalApiClient';

export function SkatVatStatementReceiptDialog() {
    const location = useLocation();
    const { skatVatStatementSubmissionId } = location.state;

    const navigate = useNavigate();
    const agreement = useCurrentAgreement();

    const [loading, setLoading] = useState<boolean>(false);
    const [receiptUrl, setReceiptUrl] = useState<string>();

    const [failed, setFailed] = useState<boolean>(false);

    useEffect(() => {
        const cleanUp = () => {
            if (receiptUrl) {
                window.URL.revokeObjectURL(receiptUrl);
            }
        };

        const fetchReceipt = async () => {
            try {
                setLoading(true);
                const receiptResponse = await internalApiClient.get(
                    `reports/vat/skat-integration/statement/${skatVatStatementSubmissionId}/receipt`,
                    {
                        responseType: 'blob',
                    }
                );

                const receiptUrl = window.URL.createObjectURL(receiptResponse.data);
                setReceiptUrl(receiptUrl);
                setLoading(false);
            } catch (error) {
                cleanUp();
                setLoading(false);
                setFailed(true);
            }
        };

        fetchReceipt();

        return cleanUp();
    }, []);

    function closeDialog() {
        navigate(location.pathname);
    }

    if (location.hash !== '#view-skat-vat-receipt' || !agreement.features.skatVatIntegration) {
        return null;
    }

    if (failed) {
        return (
            <AlertDialog defaultOpen>
                <AlertDialog.Content aria-label={t`Error`}>
                    <AlertDialog.Title>
                        <Trans>Error</Trans>
                    </AlertDialog.Title>
                    <p>
                        <Trans>An error occurred while trying to fetch the receipt. Please try again later.</Trans>
                    </p>
                    <AlertDialog.Footer>
                        <AlertDialog.Cancel>
                            <Button>
                                <Trans>Ok</Trans>
                            </Button>
                        </AlertDialog.Cancel>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog>
        );
    }

    return (
        <Dialog size="lg" defaultOpen onClose={closeDialog}>
            <Dialog.Content aria-label={t`Receipt`}>
                {({ close }) => (
                    <>
                        <Dialog.Title>
                            <Trans>Receipt</Trans>
                        </Dialog.Title>
                        {receiptUrl && <iframe width="100%" style={{ height: '60vh' }} src={receiptUrl} title={t`Receipt`} />}
                        {loading && <LoadingBox />}
                        <Dialog.Footer>
                            <Group>
                                <Button appearance="primary" onClick={close} autoFocus>
                                    <span>
                                        <Trans>Close</Trans>
                                    </span>
                                </Button>
                            </Group>
                        </Dialog.Footer>
                    </>
                )}
            </Dialog.Content>
        </Dialog>
    );
}
